import { AxiosInstance } from 'axios'
import { createContext, ReactNode, useContext, useMemo, useRef } from 'react'
import { createApiClient } from '../api/createApiClient'
import { appConfig, torqCloudConfig } from '../config'
import { AuthContext } from 'torqcloud-ui'
import { useOrganization } from './OrganizationContext'

export type ApiClientContextType = {
  torqAgentClient: AxiosInstance
  torqAgentClientNoHeaders: AxiosInstance
  torqCloudClient: AxiosInstance
}

export const ApiClientContext = createContext<ApiClientContextType>({} as ApiClientContextType)

export const ApiClientContextProvider = (props: { children: ReactNode }) => {
  const authContext = useContext(AuthContext)
  const { currentOrganizationId } = useOrganization()
  const orgId = useRef(currentOrganizationId)
  orgId.current = currentOrganizationId

  const torqAgentClient = useMemo(
    () =>
      createApiClient(
        authContext.authenticationManager,
        `${appConfig.flowiseBaseUrl}/api/v1`,
        { 'Content-type': 'application/json' },
        () => orgId.current
      ),
    [authContext.authenticationManager]
  )

  const torqAgentClientNoHeaders = useMemo(
    () => createApiClient(authContext.authenticationManager, `${appConfig.flowiseBaseUrl}/api/v1`, undefined, () => orgId.current),
    [authContext.authenticationManager]
  )

  const torqCloudClient = useMemo(
    () => createApiClient(authContext.authenticationManager, `${torqCloudConfig.url}/api`, {}, () => orgId.current),
    [authContext.authenticationManager]
  )

  return (
    <ApiClientContext.Provider value={{ torqAgentClient, torqAgentClientNoHeaders, torqCloudClient }}>
      {props.children}
    </ApiClientContext.Provider>
  )
}
